import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { CreativeSubType, CreativeType, type Creative } from '../../model';

export function CreativePreviewDialog({
  creative,
  onOpenChange,
}: {
  creative: Creative | null;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={Boolean(creative)} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>{creative?.name ?? dashboardT('creatives.preview')}</DialogTitle>
        </DialogHeader>
        {creative ? <CreativePreview creative={creative} /> : null}
      </DialogContent>
    </Dialog>
  );
}

function CreativePreview({ creative }: { creative: Creative }) {
  if (creative.type === CreativeType.Display && creative.subType === CreativeSubType.Html) {
    return (
      <iframe
        title={creative.name}
        sandbox="allow-scripts"
        srcDoc={creative.content ?? ''}
        className="border-border min-h-80 w-full rounded-md border bg-white"
      />
    );
  }
  const firstVariant = creative.variants[0];
  const source =
    creative.url ?? firstVariant?.url ?? firstVariant?.s3Url ?? firstVariant?.fileLocation;
  if (!source) {
    return (
      <p className="text-muted-foreground py-10 text-center text-sm">
        {dashboardT('creatives.noPreview')}
      </p>
    );
  }
  if (creative.type === CreativeType.Video) {
    // User-uploaded creative previews do not include a captions asset.
    // eslint-disable-next-line jsx-a11y/media-has-caption
    return <video src={source} controls className="max-h-[65vh] w-full rounded-md bg-black" />;
  }
  return (
    <img
      src={source}
      alt={creative.name}
      className="mx-auto max-h-[65vh] max-w-full object-contain"
    />
  );
}
